import * as React from "react"
import {AutocompleteAsyncSeeker} from "@ui-seeker/core"

import {BACKEND_APIS} from "@constants"
import {brandForm, customerIDForm, skuForm} from "../@signals"


export default function UnmatchedNewProductsSkuAutocomplete({ ...props }) {

    return <AutocompleteAsyncSeeker
        urlAjax={`${BACKEND_APIS.UNMATCHED}/new-products/sku`}
        label="Skus"
        placeholder="Search Skus..."
        value={skuForm.value}
        filters={{ brand: brandForm.value, customerID: customerIDForm.value }}
        onChange={e => skuForm.value = e.target.value}
        {...props}
    />
}